module.exports = __webpack_public_path__ + "static/media/Rickey Parker_1591629933215.057f741b.jpg";